import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { keys } from "../../apis";
import { settingsAPI as API, Settings } from "../../apis/settings";
import { RootState } from "../store";

export const loadSettings = createAsyncThunk(
  "loadSettings",
  (key: keys) => API.fetch(key),
  {
    condition: (key, { getState }: any) => {
      const { settings } = getState() as RootState;
      if (settings[key].data) return false;
    },
  }
);

type SettingsState = {
  status: "idle" | "loading" | "succeeded" | "failed";
  data?: Settings;
};
type State = {
  [key in keys]: SettingsState;
};
const initialState: State = {
  [keys.public]: {
    status: "idle",
  },
  [keys.cont]: {
    status: "idle",
  },
  [keys.equip]: {
    status: "idle",
  },
};

const slice = createSlice({
  name: "settings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadSettings.pending, (state, { meta }) => {
        state[meta.arg].status = "loading";
      })
      .addCase(loadSettings.rejected, (state, { meta }) => {
        state[meta.arg].status = "failed";
      })
      .addCase(loadSettings.fulfilled, (state, { payload, meta }) => {
        state[meta.arg].status = "succeeded";
        state[meta.arg].data = payload.data
      });
  },
});

export default slice.reducer;
